'use client';

import { c as _c } from "react/compiler-runtime";
import { IframeIcon } from '@/components/DetailedView/icons/IframeIcon';
import { LinkIcon } from '@/components/DetailedView/icons/LinkIcon';
import { ShareIcon } from '@/components/DetailedView/icons/ShareIcon';
import { useNotification } from '@/components/Notification';
import { Popover, PopoverArrow, PopoverContent, PopoverTrigger } from '@tallinn-arvudes/ui/atoms/popover';
import { Button } from '@tallinn-arvudes/ui/tallinn-design/Button';
import { type RefObject, useEffect, useState } from 'react';
type GetIframeProps = () => {
  title: string | null | undefined;
  src: string;
};
export const Share = t0 => {
  const $ = _c(28);
  const {
    containerRef,
    getIframeProps
  } = t0;
  const [container, setContainer] = useState(null);
  let t1;
  if ($[0] !== containerRef?.current) {
    t1 = () => {
      setContainer(containerRef?.current ?? null);
    };
    $[0] = containerRef?.current;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== containerRef) {
    t2 = [containerRef];
    $[2] = containerRef;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(t1, t2);
  const {
    clearNotification,
    showNotification
  } = useNotification();
  let t3;
  if ($[4] !== clearNotification || $[5] !== showNotification) {
    t3 = () => {
      navigator.clipboard.writeText(window.location.href).then(() => {
        showNotification({
          message: "Link kopeeritud!",
          type: "success"
        });
        setTimeout(() => {
          clearNotification();
        }, 4000);
      });
    };
    $[4] = clearNotification;
    $[5] = showNotification;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const copyLink = t3;
  let t4;
  if ($[7] !== clearNotification || $[8] !== getIframeProps || $[9] !== showNotification) {
    t4 = () => {
      if (!getIframeProps) {
        return;
      }
      const {
        title,
        src
      } = getIframeProps();
      const iframeCode = `<iframe title="${title || ""}" src="${src}" width="100%" height="100%"></iframe>`;
      navigator.clipboard.writeText(iframeCode).then(() => {
        showNotification({
          message: "Iframe kopeeritud!",
          type: "success"
        });
        setTimeout(() => {
          clearNotification();
        }, 4000);
      });
    };
    $[7] = clearNotification;
    $[8] = getIframeProps;
    $[9] = showNotification;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const copyIframe = t4;
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <PopoverTrigger asChild={true}><Button compact={true} variant="icon" tooltip="Jaga" className="text-semantic-content-faint"><ShareIcon className="!w-5 lg:!w-6 !h-5 lg:!h-6" /></Button></PopoverTrigger>;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className="text-semantic-content-brand text-lg mx-2 mb-1">Jaga</p>;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== copyLink) {
    t7 = () => {
      copyLink();
    };
    $[13] = copyLink;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <LinkIcon />;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t7) {
    t9 = <Button compact={true} variant="secondary-neutral" className="text-xs border-transparent hover:!bg-white/60 hover:!border-white/60 hover:!text-semantic-content-brand" onClick={t7} tooltip="Kopeeri link" icon={t8} iconPosition="left">LINK</Button>;
    $[16] = t7;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== copyIframe || $[19] !== getIframeProps) {
    t10 = getIframeProps && <Button compact={true} variant="secondary-neutral" className="text-xs border-transparent hover:!bg-white/60 hover:!border-white/60 hover:!text-semantic-content-brand" onClick={() => {
      copyIframe();
    }} tooltip="Kopeeri iframe" icon={<IframeIcon />} iconPosition="left">IFRAME</Button>;
    $[18] = copyIframe;
    $[19] = getIframeProps;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t9) {
    t11 = <div className="flex flex-col items-start gap-1">{t6}{t9}{t10}</div>;
    $[21] = t10;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <PopoverArrow height={15} width={15} className="fill-semantic-surface-faint" />;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== container || $[26] !== t11) {
    t13 = <Popover>{t5}<PopoverContent container={container} sideOffset={-5} onEscapeKeyDown={_temp} className="w-32 bg-semantic-surface-faint shadow-md border-none flex flex-col px-2" align="end">{t11}{t12}</PopoverContent></Popover>;
    $[25] = container;
    $[26] = t11;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
};
function _temp(e) {
  e.stopPropagation();
}